export const FIND_PLAN_CONSTANTS = {
    PHONE: 'phone',
    PROPERTY: 'property',
    CONTRACT: 'contract',
    PHONE_NUMBER_REQUIRED_MESSAGE: 'Please enter a valid Phone Number.',
    PHONE_NUMBER_INVALID_MESSAGE: 'Phone Number must have 10 digits 0-9.',
    LAST_NAME_INVALID_REQUIRED_MESSAGE: 'Please enter a valid Last Name.',
    PLAN_NUMBER_MESSAGE: 'Found in your contract (8 digits)',
    PLAN_NUMBER_REQUIRED_MESSAGE: 'Please enter a valid Plan Number.',
    PLAN_NUMBER_INVALID_MESSAGE: 'Plan Number must not contain special characters.',
    ZIP_CODE_REQUIRED_MESSAGE: 'Please enter a valid Zip Code.',
    ZIP_CODE_INVALID_MESSAGE: 'Zip Code must have 5 digits 0-9.',
    HOUSE_NUMBER_REQUIRED_MESSAGE: 'Please enter a valid House Number.',
    FIND_PLAN_API_ERROR_MESSAGE:'We were unable to find your contract. Please try again or contact us for assistance.'
}

export const FIND_PLAN_ROUTER_CONSTANTS = {
    LOGIN: 'login',
    PLAN_FOUND: 'registration/planFound',
    HOME: 'dashboard',
    PLAN_FOUND_AFTER_LOGIN: 'dashboard/planFound',
}